export default __webpack_public_path__ + "static/media/in_body_a4_by_cvrtis-da7tk3w.59dfa4f7.png";